import { Component } from '@angular/core'

import { AbstractDialogComponent } from '@shared/dialogs/abstract-dialog.component'

@Component({
  template: `
    <div ngClass.lt-md="mobile">
      <div class="header" fxLayout="row" fxLayoutAlign="space-between">
        <p>{{ data.header | translate }}</p>
        <button class="close" type="button" mat-dialog-close="" aria-label="Close dialog">
          <mat-icon svgIcon="close" ngClass.lt-md="mobile"></mat-icon>
        </button>
      </div>

      <div class="content">
        <ng-container #content></ng-container>
      </div>
    </div>
  `,
  styleUrls: ['./dialog-wrapper.component.scss'],
  standalone: false,
})
export class DialogWrapperComponent extends AbstractDialogComponent {}
